import React from 'react';

import { Button } from 'scouting-ui/lib';
import { useSlate } from 'slate-react';

import type { CustomTextKey } from './EditorTextArea.types';
import {
  isMarkActive,
  onPointerDown,
  toggleMark,
} from './EditorTextArea.utils';
import { getIcon } from './Icon';

export type MarkButtonProps = {
  format: CustomTextKey;
};

const MarkButton = ({ format }: MarkButtonProps) => {
  const editor = useSlate();

  return (
    <Button
      ghost={!isMarkActive(editor, format)}
      icon={getIcon(format)}
      onClick={() => toggleMark(editor, format)}
      onPointerDown={onPointerDown}
      size="small"
    />
  );
};

export default MarkButton;
